import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { QuestionsTimeSavedLoadAction } from '../../domains/questionsTimeSaved/actions.types';

import { QuestionsTimeSavedLifecycle } from './types';

const initialState: QuestionsTimeSavedLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<QuestionsTimeSavedLifecycle, QuestionsTimeSavedLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'QUESTIONS_TIME_SAVED.LOAD_PENDING':
      return setPending();
    case 'QUESTIONS_TIME_SAVED.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.questionsTimeSaved);
    case 'QUESTIONS_TIME_SAVED.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
